import en from './en-US'
import km from './km-Kh'

const index = {
    ...en,
    ...km
}

export default index